export default {
    SMALL: '12px',
    MEDIUM: '14px',
    LARGE: '16px',
    XLARGE: '18px',
    XXLARGE: '20px',
    XXXLARGE: '22px',
}